<template>
  <div class="pdf-container">
    <el-dialog title="财报展示" append-to-body :visible.sync="showPDF" width="1000px" :before-close="handleClose">
      <div class="content">
        <div class="content" v-for="page in pageAllNum" :key="page">
          <pdf :src="pdfSrc" :page="page"></pdf>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Cancel">取 消</el-button>
        <el-button type="primary" @click="Cancel">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import pdf from "vue-pdf";
  import { companyPusgPdf, } from '@/api/add'
  export default {
    data() {
      return {
        showPDF: true,
        pdfSrc: "", // pdf文件src
        pageAllNum: 1, // pdf文件总页数
        baseUrl: window.globalUrl.HOME_API + "admin/file/get?ossFilePath=",
        pdfLoadingTask: null // PDF加载任务
      }
    },
    components: {
      pdf,
    },
    methods: {

      async getPDF(lookPDF) {
        console.log(JSON.parse(lookPDF), 'lookPDF')
        console.log(JSON.parse(lookPDF)[0].imgUrl, 'lookPDF.imgUrl')
         // 获取PDF URL
        const pdfUrl = this.baseUrl + JSON.parse(lookPDF)[0].imgUrl;
        // console.log(pdfUrl, 'pdfUrl')
        
        // 创建PDF加载任务
        this.pdfLoadingTask = pdf.createLoadingTask(pdfUrl);
        this.pdfSrc = this.pdfLoadingTask;
        
        // 加载PDF并获取总页数
        try {
          const pdfDoc = await this.pdfLoadingTask.promise;
          this.pageAllNum = pdfDoc.numPages;
          // console.log('PDF总页数:', this.pageAllNum);
        } catch (error) {
          console.error('加载PDF失败:', error);
          this.pageAllNum = 1; // 出错时显示1页
        }

      },
      //点击关闭弹窗
      handleClose() {
        this.$emit("closeDialog3", false);
      },
      // 取消弹窗按钮
      Cancel() {
        this.$emit("closeDialog3", false);
      },
    },
  }

</script>
<style lang="less" scoped>
  .content {
    width: 90%;
    min-width: 860px;
    margin: 10px auto;
    padding: 10px;
    background: rgba(85, 85, 85, 0.1);
    box-sizing: border-box;
    margin-top: 0;
  }
</style>